<template>
<div class="btomLine">
        <calanderContent :selectActivity.sync="selectActivity" @clear="clear"></calanderContent>
        <div class="mask" v-show="selectActivity" @click="clear"></div>
        <div class="my-container addwidth">
        <ul class="ActList">    
            <li v-for="(item,index) in ActList" :key="index" @click="showLimitActivity(index)">
                <div>
                    <img :src="item.img" alt="">
                    <span>
                        {{item.text}}
                    </span>
                    <i class="flash"></i>
                </div>
            </li>  
        </ul>
        </div>
        <div class="my-container">
            <div class="row wrapper">
                <div v-for="(item,index) in list" class="col-xs-3 item" :key="index">
                    <div class="innerWrap">
                        <img class="Avatar"  :src="item.img"  />
                        <h2>{{item.h1}}</h2>
                        <div class="pBox">
                        <p v-for="(item,index) in item.p" :key="index">
                            {{item}}
                        </p>
                        </div>
                        <div class="over-hide information">
                            <div><img class="wechats" :src="item.href" /></div>
                            <a :href="item.regist" target="_blank" class="block" >登录</a>
                            <a :href="item.index"  target="_blank" class="block">注册</a>
                            <!--  -->
                        </div>
                    </div>
                </div>
            </div>
         </div>
</div>
</template>
<script>
// import aos from 'aos'
import axios from '../axios'
import calanderContent from './a.header.calander.content.vue'
export default {
    data() {
        return {
            ActList:[
                {
                    img: require('../assets/images/ActInfo1.jpg'),
                    text: "特邀真人首存"
                },
                {
                    img: require('../assets/images/ActInfo0.jpg'),
                    text: "电子首存优惠"
                },
                
                {
                    img: require('../assets/images/ActInfo2.jpg'),
                    text: "老虎机再存活动"
                },
                {
                    img: require('../assets/images/ActInfo4.jpg'),
                    text: "666好运金"
                },
                {
                    img: require('../assets/images/ActInfo3.jpg'),
                    text: "加盟合作"
                },
                
                // {
                //     img: require('../assets/images/ActInfo5.jpg'),
                //     text: "免费转大奖"
                // },
                {
                    img: require('../assets/images/ActInfo6.jpg'),
                    text: "天长地久"
                },
            ],
            list: [
                {
                    img: require('../assets/images/server10.png'),
                    href: require('../assets/images/serverIcon10.jpg'),
                    h1:"小茹",
                    p:['用我百分百的努力','换你百分百的满意'],
                    regist:"https://idj7888.com",
                    index:"https://idj7888.com/Member/Register"
                },
                {
                    img: require('../assets/images/server2.png'),
                    href: require('../assets/images/serverIcon2.jpg'),
                    h1:"贝贝",
                    p:['客户虐我千百遍','我当客户如初恋'],
                    regist:"https://6065vip.com/Member/Register",
                    index:"https://6065vip.com/Member/Register"
                },
                {
                   img: require('../assets/images/server3.png'),
                    href: require('../assets/images/serverIcon3.png'),
                    h1:"乐乐",
                    p:['心怀善良，能利人','心怀感恩，能利己！'],
                    regist:"https://djlh81.com",
                    index:"https://djlh81.com/Member/Register"
                },
                {
                    img: require('../assets/images/server20.png'),
                    href: require('../assets/images/serverIcon20.jpg'),
                    h1:"柒柒",
                    p:['没有华丽的语言','只有真诚的服务'],
                    regist:"http://68pt8.com",
                    index:"http://68pt8.com/Member/Register"
                },
                {
                   img: require('../assets/images/server9.png'),
                    href: require('../assets/images/serverIcon9.jpg'),
                    h1:"七月",
                    p:['您的满意 是我的动力 ','风里雨里月月在大奖等你  '],
                    regist:"https://68pt8.com",
                    index:"https://68pt8.com/Member/Register"
                },

                {
                    img: require('../assets/images/server6.png'),
                    href: require('../assets/images/serverIcon6.jpg'),
                     h1:"欢欢",
                    p:['售前的奉承','不如售后的服务'],
                    regist:"https://djlh83.com",
                    index:"https://djlh83.com/Member/Register"
                },
                {
                    img: require('../assets/images/server7.png'),
                    href: require('../assets/images/serverIcon7.png'),
                    h1:"幽幽",
                    p:['押对注赢一次','押对人赢一生'],
                    regist:"https://djlh83.com",
                    index:"https://djlh83.com/Member/Register"
                },
                {
                   img: require('../assets/images/server8.png'),
                    href: require('../assets/images/serverIcon8.jpg'),
                    h1:"小花",
                    p:['红颜知己，','不如陪你东山再起'],
                    regist:"https://6065vip.com",
                    index:"https://6065vip.com/Member/Register"
                },
                {
                    img: require('../assets/images/server5.png'),
                    href: require('../assets/images/serverIcon5.png'),
                    h1:"小七",
                    p:['一个简单的接待','比一个详细说明书要好'],
                    regist:"https://djlh85.com",
                    index:"https://djlh85.com/Member/Register"
                },
                
                
                {
                    img: require('../assets/images/server1.png'),
                    href: require('../assets/images/serverIcon1.jpg'),
                    h1:"娜娜",
                    p:['出入有境  服务无境'],
                    regist:"https://idj7888.com ",
                    index:"https://idj7888.com/Member/Register"
                },
            ],
            showIndex: -1,
            selectActivity:null,
            activity: [],
            top:0,
        }
    },
    mounted() {
        // aos.init()
    },
     components: {
         calanderContent
    },
    created(){
        let that=this;
         axios.getActivity(function(data) {
            that.activity = data.data.activity;
            that.activity = that.activity.map(function(e) {
                e.img = /^http:\/\/|^https:\/\//i.test(e.img) ? e.img : require('../assets/images/' + e.img)
                //dateCommand
                // if(e.dateCommand){
                //     //每周一
                //     if(e.dateCommand == "everyMonday"){
                //         e.date = [];
                //         let currentDate = new Date();
                //         for(let day=1;day<=31;day++){
                //             let week = new Date(currentDate.getFullYear()+'/'+that.month+'/'+day).getDay();
                //             if(week==1){
                //                 e.date.push(day)
                //             }
                //         }
                //     }
                // }
                return e;
            })
        })
    },
    methods: {
        clear(){
            document.getElementsByTagName("html")[0].className = "static";
            window.scrollTo(0, this.top)
            this.selectActivity=null
        },
        showLimitActivity(index){
            let that = this;
            if(this.activity.length>0){            
                this.top = document.documentElement.scrollTop || document.body.scrollTop
                document.getElementsByTagName("html")[0].className = "fixed";
                document.getElementsByTagName("html")[0].style.top = -this.top + "px";
                window.scrollTo(0, this.top)
                let newArray=[];
                newArray.push(that.activity[index])
                that.selectActivity = newArray
            }
        },
    }
}
</script>
<style scoped>
.block{
    display: block;
    background: #fedb58;
    width: 55%;
    margin: 10px auto;
    text-decoration: none;
    padding: 2px 0;
    color: black;
    border-radius: 2px;
    transition: 0.5s;
    font-size: 16px;
}
.block:hover{
    background: #fdc800;
}
.ActList{
    overflow: hidden;
    margin:40px 0 40px;
}


.ActList li{
    width: 16%;
    float: left;
    text-align:center;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    
}
.ActList li img{
    display: block;
    width: 80%;
    margin: 0 auto;
    border: 1px  solid #bda54b;
    border-bottom: 0;
    
}
.mask{
    position: fixed;
    background: rgba(0,0,0,0.8);
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
}
.ActList li div{
    position: relative;
    z-index: 1;
}

.ActList li div .flash {
          position: absolute;
          top: 0px;
          left: 10%;
          width: 80%;
          height: 100%;
          overflow: hidden;
}
.ActList li div  .flash::after {
            content: "";
            background: transparent;
            position: absolute;
            top: 0;
            left: -80px;
            width: 63px;
            height: 100%;
            transition: all 0.8s;
            opacity: 0.9;
 }
 .ActList li div:hover .flash::after {
    background: url(../assets/images/glitteringImg.png) no-repeat 100% 100%;
    background-size: 70% 100%;
    left: 100%;    
   }
.ActList li span{
    color: #ffffff;
    font-size: 16px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #3c3c3c;
    display: block;
    width: 80%;
    margin: 0 auto;
    border: 1px  solid #bda54b;
    border-top: 0;
}
.btomLine{
    background: url(../assets/images/secFloorBg.jpg) no-repeat center top;
    overflow: hidden;
    padding-bottom: 30px;
    border-bottom: 2px  solid #bda54b;
}


.wrapper{
    color: white;
    text-align: center;
}
.wrapper h2{
    font-size: 24px;
}
.wrapper p{
    line-height: 12px;
    font-size: 16px;
}
.wrapper .innerWrap{
   margin: 10px;
   position: relative;
   background: rgba(0,0, 0, 0.5);
   border: 1px solid #bda54b; 
}
.wrapper .innerWrap .Avatar{
    margin-top:15%;
}
.wrapper .innerWrap .pBox{
    height: 60px;
}
.wrapper .innerWrap .Avatar{
    margin-top:10%;
}

.col-xs-3 {
    text-align: center;
    position: relative;
    height: 100%;
   
}

.over-hide {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    transition: 0.5s;
}

.col-xs-3:hover .over-hide {
    opacity: 1;
}

img.wechats {
    width: 130px;
    height: 130px;
    margin-top: 40px;
}
.col-xs-3 {
    width: 20%;
}
  .my-container.addwidth{
        width: 1386px
    }
@media screen and (min-width:768px){
    .ActList li{
        margin-left:0.51%; 
    }
}
@media screen and (max-width:768px){
    .wrapper h2{
        font-size: 16px;
    }
    .wrapper p{
       font-size: 13px; 
       line-height: 14px;
    }
    .ActList{
      margin:10px auto;
    }
   .ActList li{
        width: 33.3%;
        float: left;
        text-align:center;
        position: relative;
        cursor: pointer;
        top: 0;
        left: 0;
        font-size: 12px;
        margin-bottom: 10px;
        
    }   
    .ActList li span{
        font-size: 13px;
    } 
    .my-container{
        margin: 0;
    }
    .my-container.addwidth{
        width: 100%;
    }
    .ActList li .flash {
          position: absolute;
          top: 0px;
          left: 10%;
          width: 80%;
          height: 80px;
          overflow: hidden;
    } 
    .btomLine{
        background-size: cover;
    }
    .wrapper .innerWrap .pBox{
        height: 50px;
    }
}

</style>





// WEBPACK FOOTER //
// src/components/b.wechat.vue